<nav class="navbar navbar-expand-lg bg-body shadow">
  <div class="container-lg">
    <button class="navbar-toggler border-0" data-bs-target="#navbarCanvas" data-bs-toggle="offcanvas" type="button" aria-controls="navbarCanvas" aria-expanded="false" aria-label="Toggle Navigation" i18n-aria-label>
      <span class="navbar-toggler-icon"></span>
    </button>

    <a class="navbar-brand me-lg-3" [routerLink]="['/']" aria-label="Hakikat Main Page" i18n-aria-label>
      <img class="nav-logo" src="/icons/logo.svg" style="width: 3rem;" alt="Logo" i18n-alt>
    </a>

    <div class="offcanvas-lg offcanvas-start flex-grow-1" id="navbarCanvas">
      <div class="offcanvas-header bg-secondary">
        <img class="mx-auto my-3" src="/icons/logo-white.svg" style="width: 5rem;" i18n-alt>
      </div>
      <div class="offcanvas-body" tabindex="-1" role="dialog" aria-modal="true">
        <ul class="navbar-nav">
          <li class="nav-item">
            <button class="nav-link" data-bs-target="#navbarCanvas" data-bs-toggle="offcanvas" [routerLink]="['/']" type="button" aria-label="Home" i18n i18n-aria-label>Ana Sayfa</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" data-bs-target="#navbarCanvas" data-bs-toggle="offcanvas" [routerLink]="['/']" [fragment]="'about'" type="button" aria-label="About Us" i18n i18n-aria-label>Hakkımızda</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" data-bs-target="#navbarCanvas" data-bs-toggle="offcanvas" [routerLink]="['/']" [fragment]="'activities'" type="button" aria-label="Activities" i18n i18n-aria-label>Faaliyetler</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" data-bs-target="#navbarCanvas" data-bs-toggle="offcanvas" [routerLink]="['/']" [fragment]="'apply'" type="button" aria-label="Apply as Volunteer" i18n i18n-aria-label>Başvuru</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" data-bs-target="#navbarCanvas" data-bs-toggle="offcanvas" [routerLink]="['/']" [fragment]="'team'" type="button" aria-label="Team" i18n i18n-aria-label>Takım</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" data-bs-target="#navbarCanvas" data-bs-toggle="offcanvas" [routerLink]="['/']" [fragment]="'testimonials'" type="button" aria-label="Testimonials" i18n i18n-aria-label>Referanslar</button>
          </li>
        </ul>
      </div>
      <div class="offcanvas-footer d-lg-none text-center">
        <app-localize />
        <hr>
        <app-auth class="dropup" />
      </div>
    </div>

    <div class="navbar-actions d-flex align-items-center gap-3">
      <app-cart />
    </div>
  </div>
</nav>